<div class="bubble-wrapper">
  <div *ngIf="isExternalLink" class="nav-bubble mb-2 d-flex align-items-center justify-content-center">
    <div>
      <a href="{{linkUrl}}"><img [src]="'assets/images/my-account/icons/' + icon" title="{{linkText}}" alt="{{linkText}}" class="icon"></a>
    </div>
  </div>
  <div *ngIf="!isExternalLink" class="nav-bubble mb-2 d-flex align-items-center justify-content-center" [routerLink]="linkUrl">
    <div>
      <img [src]="'assets/images/my-account/icons/' + icon" title="{{linkText}}" alt="{{linkText}}" class="icon">
    </div>
  </div>
  <div class="text-center">
    <a *ngIf="!isExternalLink" [routerLink]="linkUrl" class="text-white">{{linkText}}</a>
    <a *ngIf="isExternalLink" [href]="linkUrl" class="text-white">{{linkText}}</a>
  </div>
</div>
